module.exports = __webpack_public_path__ + "static/logo_white-382dae1e632cbacaf18568d0eeaba248.svg";